import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { GenericHttpService } from '../generic-http.service';
import { ConfiguracoesProjeto } from './../../shared/model/configuracoes-projeto.model';
import { MunicipioModel } from './../model/municipio.model';
import { ParametrosService } from './parametros.service';
import { FiltroBuscaMunicipios } from '../filter/filtro-municipios';

@Injectable()
export class MunicipioService {
  public _urlBase: string;
  public configuracao: ConfiguracoesProjeto;

  public muncipioChange: Subject<MunicipioModel> = new Subject<MunicipioModel>();
  public municipioErrors: Subject<string> = new Subject<string>();
  public municipio: MunicipioModel;

  constructor(
    private readonly genericHttpService: GenericHttpService<MunicipioModel>,
    private readonly parametrosService: ParametrosService
  ) {}

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'municipio';

    return this._urlBase;
  }

  public getMunicipiosPorUF(uf: string): Observable<MunicipioModel[]> {
    return this.genericHttpService.getAll(this.urlBase + `/listagem-por-uf/${uf}`);
  }

  public getMunicipiosIBGE(codIBGE: number) {
    const api = `/listagem_por-codigo-ibge/${codIBGE}`;
    this.genericHttpService.getById(this.urlBase + api).subscribe(
      data => {
        this.municipio = <MunicipioModel>data;

        if (!this.municipio.nome) {
          this.municipio = new MunicipioModel('Salvador');
          this.municipio.unidadeFederacaoId = 'BA';
        }

        this.muncipioChange.next(this.municipio);
      },
      errors => {
        this.municipio.nome = 'Salvador';
        this.municipio.unidadeFederacaoId = 'BA';
        this.municipioErrors.next(errors);
        this.muncipioChange.next(this.municipio);
      }
    );
  }

  public getMunicipio(): MunicipioModel {
    return this.municipio;
  }

  public getListagemMunicipios(filtro: FiltroBuscaMunicipios): Observable<MunicipioModel[]> {
    return this.genericHttpService.getAllParamFull(this.urlBase + `/listagem`, filtro);
 }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/municipio.service.ts